export const PRODUCT = {
  id: 1,
  nameEn: "MISKY Face & Body Cream",
  nameAr: "كريم مسكي للوجه والجسم",
  taglineEn: "Ceramide Complex 2%",
  taglineAr: "عناية يومية مطمئنة",
  subtitleEn: "Daily Skin Care",
  subtitleAr: "عناية يومية",
  capacity: "150 ml",
  price: 15,
  currency: "JD",
  descriptionEn:
    "Enjoy soft, hydrated skin all day long with our lightweight moisturizer enriched with Ceramide NP & NG, Aloe Vera Extract. It helps nourish and hydrate the skin while maintaining its softness and natural radiance, without leaving any greasy feel or excess shine.",
  descriptionAr:
    "استمتعي ببشرة رطبة طوال اليوم مع مرطبنا الخفيف الغني بخلاصة الألوفيرا، والسيراميد التي تساعد على ترطيب البشرة والحفاظ على نعومتها وإشراقتها دون ترك أي ملمس دهني أو لمعان زائد.",
  badges: ["ملمس خفيف", "حماية يومية", "لطيف على البشرة", "مناسب للاستخدام اليومي"],
  warnings: [
    "يُحفظ في درجة حرارة أقل من 30 درجة مئوية بعيداً عن أشعة الشمس.",
    "يحفظ بعيداً عن متناول الأطفال.",
    "لا يستخدم على العين.",
    "في حال التهيج وقف الاستخدام فوراً.",
  ],
  warningsEn: [
    "Store below 30°C, away from sunlight.",
    "Keep out of reach of children.",
    "Avoid contact with the eyes.",
    "If irritation occurs, stop use immediately.",
  ],
  howToUse: [
    { icon: "💧", ar: "ضعي كمية مناسبة من الكريم على بشرة نظيفة وجافة.", en: "Apply an appropriate amount on clean dry skin." },
    { icon: "🔄", ar: "وزعي الكريم بلطف على الوجه والرقبة بحركات دائرية.", en: "Gently spread on face and neck with circular motions." },
    { icon: "☀️", ar: "يُستخدم صباحاً ومساءً للحصول على أفضل النتائج.", en: "Use morning and evening for best results." },
    { icon: "📅", ar: "المواظبة اليومية تمنح بشرتك مظهراً صحياً ومتوازناً.", en: "Daily use gives your skin a healthy, balanced look." },
  ],
  ingredients:
    "Aqua, Cetyl Alcohol, Stearic Acid, Urea, Glyceryl Stearate, Glycerin, Paraffinum Liquidum, Steareth-20, Petrolatum, Ceramide NP, Ceramide NG, Aloe Barbadensis (Aloe Vera) Extract, Butyrospermum Parkii (Shea) Butter, Prunus Amygdalus Dulcis (Sweet Almond) Oil, Ricinus Communis (Castor) Oil, Phenoxyethanol, Parfum, Dimethicone, Potassium Sorbate, Sodium Benzoate, Hexyl Cinnamal, Tri Ethanol Amine, Linalool, Citronellol, Limonene, Geraniol.",
  keyIngredients: [
    { name: "Ceramide Complex 2%", desc: "Restores the skin barrier and locks in moisture all day.", icon: "🔬" },
    { name: "Aloe Vera Extract", desc: "Soothes, calms and deeply hydrates the skin.", icon: "🌿" },
    { name: "Shea Butter", desc: "Rich nourishment for soft, supple skin.", icon: "🧴" },
    { name: "Sweet Almond Oil", desc: "Lightweight oil that conditions without greasiness.", icon: "🌰" },
  ],
};

export const CONTACT = {
  location: "Jordan / Amman / Khalda",
  phone: "0799331059",
  email: "Fadelsous@icloud.com",
  whatsapp: "962799331059",
};
